/**
 * Transforme un URLSearchParams en un objet JavaScript typé
 * Gère les cas suivants:
 * - Paramètres simples: 'key=value' -> { key: 'value' }
 * - Tableaux: 'field[]=1&field[]=2' -> { field: ['1', '2'] }
 * - Objets imbriqués: 'user[name]=John' -> { user: { name: 'John' } }
 */
export function parseSearchParams(urlParams: URLSearchParams) {
  if (!(urlParams instanceof URLSearchParams)) {
    throw new TypeError('Input must be an instance of URLSearchParams');
  }

  const result: Record<string, any> = {};

  for (const [key, value] of urlParams.entries()) {
    // Vérifier si c'est un tableau (se termine par [])
    const isArray = key.endsWith('[]');
    const cleanKey = isArray ? key.slice(0, -2) : key;

    if (isArray) {
      // Initialiser le tableau s'il n'existe pas
      if (!result[cleanKey]) {
        result[cleanKey] = [];
      }
      if (Array.isArray(result[cleanKey])) {
        (result[cleanKey] as string[]).push(value);
      }
    } else if (key.includes('[') && key.includes(']')) {
      // Gestion des objets imbriqués (ex: user[name])
      const matches = key.match(/(.*?)\[(.*?)\]/);
      if (matches) {
        const [, parentKey, childKey] = matches;
        if (!result[parentKey] || typeof result[parentKey] === 'string') {
          result[parentKey] = {};
        }
        if (
          typeof result[parentKey] === 'object' &&
          !Array.isArray(result[parentKey])
        ) {
          (result[parentKey] as Record<string, string>)[childKey] = value;
        }
      }
    } else {
      // Paramètre simple
      result[key] = value;
    }
  }

  return result;
}
